import {
  AfterViewInit,
  Component,
  EventEmitter,
  Input,
  OnDestroy,
  OnInit,
  Output,
} from "@angular/core";
import { Static, Tarea, Usuario } from "@app/shared";
import { LocalDataSource } from "ng2-smart-table";
import { Subject } from "rxjs";
import { CopyToConfig } from "./shared/copy-to-config.service";
import { CopyToDataService, Dependencie } from "./shared/copy-to.data.service";

@Component({
  selector: "iw-copy-to",
  templateUrl: "./copy-to.component.html",
  styleUrls: ["./copy-to.component.scss"],
  providers: [CopyToDataService]
})
export class CopyToComponent implements OnInit, OnDestroy, AfterViewInit {
  // Tarea actual
  @Input() task: Tarea;
  // Oculta o muestra el boton de regresar
  @Input() single = true;
  // Oculta o muestra el titulo del componente
  @Input() title: Boolean = true;
  // Define si la tarea está finalizada
  @Input() finishTask: boolean = false;
  // Define cuando activar la previsualizacion de informacion de flujo
  @Input() previewFlow = false;
  //Define si el usuario entró a través del ícono Lápiz (Modificar radicación)
  @Input() modify: boolean = false;
  // Variable a la cual se le injectan las configuraciones de la tabla.
  settings = {};
  // Datos para llenar la tabla
  source: LocalDataSource;
  // lista de dependencias para el control
  list: Dependencie[] = [];
  // Referencia a la dependencia seleccionada
  selectedDependencie: any;
  // Referencia a los funcionarios de la tarea actual
  functionaries: Usuario[] = [];
  // Referencia a los usuarios seleccionados
  selectedFunctionaries: any[] = [];
  // Habilitar o deshabilitar el botón
  sendCopy = false;
  // variable que muestra el cargando funcionarios
  loading = false;
  // responsables a asignar o eliminar
  responsables: any[] = [];
  // Evento que emite al presionar el boton de cerrar
  @Output() close: EventEmitter<boolean> = new EventEmitter();
  // controla la finalización de la tarea
  @Output() validCopy: EventEmitter<boolean> = new EventEmitter();
  // Destruye y gestiona el memory leak
  private destroy: Subject<void> = new Subject<void>();

  constructor(private cds: CopyToDataService) {
  }

  ngOnInit() {
    if(this.previewFlow){
      this.finishTask = true;
    }
    const docsC = new CopyToConfig();
    this.settings = docsC.settings;
    this.functionaries = Static.copyObjet(this.task.responsables);
    this.getDependencie();
  }

  ngAfterViewInit(){
    this.getUsersTask();
  }

  /**
   *Obtiene las dependencias
   *
   * @memberof CopyToComponent
   */
  getDependencie(){
    this.cds.getDependencies().subscribe(async res=>{
      if(res){
        this.list = await res;
      }
    });
  }

  /**
   *Obtiene los usuarios asignados por tarea
   *
   * @memberof CopyToComponent
   */
  getUsersTask(){
    this.cds.getUserTask(this.task.id).subscribe(async res=>{
      if(res){
        this.selectedFunctionaries = await res;
        if(this.selectedFunctionaries.length){
          let first_user = this.selectedFunctionaries[0];
          if(first_user && first_user.sede){
            this.selectedDependencie = first_user.sede;
            this.fillTableFunctionaries();
          }
          this.validCopy.emit(true);
        }else{
          this.validCopy.emit(false);
        }
      }
    });
  }

  /**
   * Emite el evento de regresar
   *
   * @returns {*}
   * @memberof CopyToComponent
   */
  closeComponent(): any {
    this.close.emit(true);
  }

  ngOnDestroy() {
    this.destroy.next();
    this.destroy.complete();
  }


  /**
   *Controla cuando el usuario da click sobre la tabla
   *Añade un funcionario a la lista de funcionarios a asignar
   * @param {*} data
   * @memberof CopyToComponent
   */
   clikRowSelect(data: any) {
    let exist = false;
    this.selectedFunctionaries.forEach(sf=>{
      if(sf.id == data.data.id){
        exist = true;
      }
    })
    if(!exist){
      exist = false;
      let index = 0;
      this.responsables.forEach((rs, i)=>{
        if(rs.usuario_id == data.data.id && rs.accion == 'eliminar'){
          exist = true;
          index = i;
        }
      })
      if(exist){
        this.responsables.splice(index, 1);
        this.selectedFunctionaries.push(data.data);
      }else{
        let responsible = {usuario_id: data.data.id, accion: 'crear'};
        this.responsables.push(responsible);
        this.selectedFunctionaries.push(data.data);
      }
    }
  }


  /**
   *Elimina un funcionario de la lista de asignaciones
   *
   * @param {Usuario} user
   * @memberof CopyToComponent
   */
   dropFunctionary(user: Usuario) {
    let index = this.selectedFunctionaries.indexOf(user);
    this.selectedFunctionaries.splice(index, 1);
    let accion = 'eliminar';
    if(this.responsables.length){
      this.responsables.forEach((rs, i)=>{
        if(rs.usuario_id == user.id && rs.accion == 'crear'){
          index = i
          accion = rs.accion;
        }
      });
    }
    if(accion == 'eliminar'){
      let responsible = {usuario_id: user.id, accion: 'eliminar'};
      this.responsables.push(responsible);
    }
    if(accion == 'crear'){
      this.responsables.splice(index, 1);
    }
  }


  /**
   *Detecta los cambios en la dependencia
   *
   * @param {*} data
   * @memberof CopyToComponent
   */
  changeDependencie(data: any){
    if (data !== null) {
      this.functionaries.length = 0;
      this.fillTableFunctionaries()
      this.sendCopy = true;
    } else {
      this.sendCopy = false;
    }
  }

  
   /**
    *Consulta los usuarios por dependencia
    *
    * @memberof CopyToComponent
    */
    fillTableFunctionaries(){
      this.loading = true;
      this.cds.getUsersDependencie(this.selectedDependencie).subscribe(async res=>{
        if(res){
          this.functionaries = await res;
          this.source = new LocalDataSource(this.functionaries);
          this.loading = false;
        }else{
          this.loading = false;
        }
      }, ()=>{
        this.loading = false;
      })
    }

  /**
   *asigna usuarios a con copia a 
   *
   * @memberof CopyToComponent
   */
   asignUsers(){
    this.cds.asignUsers(this.task.id, this.responsables).subscribe(res=>{
      if(res){
        this.getUsersTask();
        this.responsables.length = 0;
      }
    })
  }
}



// WEBPACK FOOTER //
// ./src/app/forms/shared/copy-to/copy-to.component.ts